import React, {Component} from 'react';

import Divider from '@mui/material/Divider';
import FileUploadIcon from '@mui/icons-material/CloudUpload';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

const s:any = {
  container: {
    display:'flex',
    justifyContent:'flex-start',
    alignItems: 'center'
  },
  preview: {
    width:200,
    height: 40,
    mt: 1,
    ml: 1,
    mr: 1,
  },
  button: {
    m: 1
  },
  input: {
    display: 'none',
  },
  hidden: {
    display: 'none'
  },
  visible: {
    display: 'flex'
  }
};

class FFileUpload extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      source: undefined,
      value: ' ',
    };
  }

  getxid = () => {
    const {id='upfile'} = this.props;
    const xid = `_${id}`;
    return xid;
  }
  
  getxname = () => {
    const {name='upfile'} = this.props;
    const xname = `_${name}`;
    return xname;
  }
  
  disableEvent = (event:any) => {
    event.preventDefault();
  };
  onMouseDown = (event:any) => {
    event.preventDefault();
  };

  onOpen = (event:any) => {
    const xid = this.getxid();
    const input = document.getElementById(xid);
    if(input) input.click();
  }

  setSource = async(event:any,file:any,result:any) => {
    const {onChange} = this.props;
    const {name:filename,size,lastModified:stamp} = file;
    console.log('file: ',file);

    if(typeof onChange === 'function') {
      const payload = {name:filename,size,data:result,stamp};
      const filedata = btoa(JSON.stringify(payload));
      onChange(filedata);
    }

    this.setState({value:filename,source:result});
  }

  onChanged = async(event:any) => {
    event.persist();
    const files:any = event.target.files || event.dataTransfer.files;
    if (files) {
      const file = files[0];
      const result = new Blob(file);
      await this.setSource(event,file,result);
    }
  }

  onChange = (event:any) => {
    event.persist();
    const files:File[] = event.target.files || event.dataTransfer.files;
    if (files) {
      const file = files[0];
      
      const {onChange} = this.props;
      const {name:filename,size,lastModified:stamp} = file;
      console.log('file: ',file);

    if(typeof onChange === 'function') {
      onChange(file);
    }

    this.setState({value:filename});
    }
  }

  render() {
    const {id,label,name,required,options,previewStyle,divider,classes } = this.props;
    const {preview,accept,InputProps:inprops={},...ooptions} = options||{};
    const {value} = this.state;

    var xid = this.getxid();
    var xname = this.getxname(); 
    var xaccept = accept || "*/*";

    return (

      <React.Fragment>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            required={required}
            margin='dense'
            fullWidth={true}
            sx={{...s.textField}}            
            value={value}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <label htmlFor={xid}>
                  
                  <IconButton 
                    color={'primary'}
                    onClick={this.onOpen}
                  >
                    <FileUploadIcon color={'inherit'}/>
                    <input
                      style={{opacity:0,width:1}}
                      accept={xaccept}
                      id={xid}
                      name={xname}
                      type="file"
                      onChange={this.onChange}
                    />
                  </IconButton>
                  
                  </label>
                </InputAdornment>
              ),
            }}
            onKeyDown={this.disableEvent}
          />
        {divider && <Divider />}
      </React.Fragment>
    );
  }
}

export default FFileUpload;
